import { useTranslation } from "react-i18next";
import "../userInf.scss";
import {
  alertControl,
  englishRegex,
  modalControl,
  numberRegex,
  specialCharRegex,
  successControl,
} from "util/commAction";
import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { lgnPwdResetApi } from "components/api/user";

type IProps = {
  emlId: string;
};

export default function PwdReset({ emlId }: IProps) {
  const { t } = useTranslation();

  const [lgnPwd, setLgnPwd] = useState("");

  const [valid, setValid] = useState({
    isEnCharValid: false,
    isNumCharValid: false,
    isSpecialCharValid: false,
    isRangeCharValid: false,
    isEquali: false,
  });

  const lgnPwdResetMutation = useMutation({
    mutationFn: lgnPwdResetApi,
    onSuccess: (res) => {
      if (res) {
        successControl({
          status: res.status,
          success: () => {
            alertControl({
              isOpen: true,
              inner: t("txt_pwd_sett_mpg"),
              click: () => {
                modalControl({
                  isOpen: false,
                });
              },
            });
          },
        });
      }
    },
  });

  // 비밀번호 재 설정
  const handleResetPwd = () => {
    alertControl({
      isOpen: true,
      inner: "비밀번호를 재설정 하시겠습니까?",
      cncl_btn: true,
      click: () => {
        lgnPwdResetMutation.mutate({
          lgnPwd,
          emlId,
        });
      },
    });
  };

  const isAble = Object.values(valid).every((value) => value === true);

  return (
    <div className="modal-inner">
      <div className="h-[72px]">
        <h3 className="text-center">{t("ttl_md_pss_mpg")}</h3>
        <h6 className="text-center text-gray-500">{t("ttl_dscrp_md_mpg")}</h6>
      </div>
      <form className="pwd-rst-form">
        <input
          type="password"
          name="lgnPwd"
          onChange={(e) => {
            const value = e.currentTarget.value;
            setValid({
              ...valid,
              isEnCharValid: englishRegex.test(value) ? true : false,
              isNumCharValid: numberRegex.test(value) ? true : false,
              isSpecialCharValid: specialCharRegex.test(value) ? true : false,
              isRangeCharValid:
                value.length >= 8 && value.length <= 20 ? true : false,
            });

            setLgnPwd(e.currentTarget.value);
          }}
        />
        <div className="flex gap-3 mb-2 mt-0 md:mb-6 mt-2">
          <h6 className={valid.isEnCharValid ? "on" : ""}>
            {" "}
            {t("txt_en_cmm")}
          </h6>
          <h6 className={valid.isNumCharValid ? "on" : ""}>
            {t("txt_num_cmm")}
          </h6>
          <h6 className={valid.isSpecialCharValid ? "on" : ""}>
            {t("txt_spc_cmm")}
          </h6>
          <h6 className={valid.isRangeCharValid ? "on" : ""}>
            8 ~ 20 {t("txt_lss_cmm")}
          </h6>
        </div>
        <input
          type="password"
          name="lgnPwdcheck"
          onChange={(e) => {
            const value = e.currentTarget.value;

            setValid({
              ...valid,
              isEquali: value === lgnPwd,
            });
          }}
        />
        <h6 className={"mt-0 md:mt-2" + " " + (valid.isEquali ? "on" : "")}>
          {t("txt_pss_mtch_cmm")}
        </h6>
      </form>
      <div className="center">
        <button
          className="btn w-[100px]"
          disabled={!isAble}
          onClick={handleResetPwd}
        >
          {t("btn_hm_cnf")}
        </button>
      </div>
    </div>
  );
}
